export enum ContractType {
  Competent = "competent",
  Coordinated = "coordinated",
  Coordinator = "coordinator",
}
